<template>
  <div>
    <div class="flex-box">
      <div class="qr-code" ref="qrCodeUrl"></div>
      <div>我的二维码,仅供推广用户使用</div>
    </div>
  </div>
</template>
div>
<script>
import QRCode from 'qrcodejs2'

export default {
  data() {
    return {
      qr:''
    };
  },
  created() {
    this.getQr();
  },
  methods: {
    /* 创建二维码 */
    creatQrCode(param) {
      console.log(param)
      new QRCode(this.$refs.qrCodeUrl, {
        text: param, // 二维码的内容
        width: 250,
        height: 250,
        colorDark: '#000',
        colorLight: '#fff',
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    // 获取二维码内容
    getQr(){
      this.$api.post("/api/user_center/getShareCode" ,{}, res => {
        if (res.status == 200) {
          this.qr= res.data;
          this.creatQrCode(this.qr); // 创建二维码
        } else {
          this.$message.error(res.msg);
        }
      })
    }
  },
};
</script>
<style scoped>
.flex-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.qr-code {
  padding: 10px;
  margin-top: 50px;
  background-color: #fff;
  /*border: 1px solid red;*/
}
</style>

